<template>
  <div>
    <el-form
      :model="formData"
      ref="ruleForm"
      :rules="rules"
      label-position="left"
      label-width="80px"
      size="default"
    >
      <div class="table-container">
        <el-row :gutter="20" justify="middle" align="center">
          <el-col :span="24">
            <div class="grid-content"><h2>发货申请单</h2></div>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="4"> <div class="grid-content">购货公司</div> </el-col>
          <el-col :span="8"
            ><div class="grid-content">
              <el-input
                v-model="formData.companyName"
                clearable="true"
              ></el-input></div
          ></el-col>
          <el-col :span="4"><div class="grid-content">申请原因</div></el-col>
          <el-col :span="8"
            ><div class="grid-content">
              <el-input
                v-model="formData.applyCause"
                clearable="true"
              ></el-input></div
          ></el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="4">
            <div class="grid-content">使用设备及描述</div>
          </el-col>
          <el-col :span="8"
            ><div class="grid-content">
              <el-input
                v-model="formData.useDevice"
                clearable="true"
              ></el-input></div
          ></el-col>
          <el-col :span="4"><div class="grid-content">备注</div></el-col>
          <el-col :span="8"
            ><div class="grid-content">
              <el-input
                v-model="formData.remark"
                clearable="true"
              ></el-input></div
          ></el-col>
        </el-row>
        <el-row :gutter="20" justify="middle" align="center">
          <el-col :span="24">
            <div class="grid-content">申请内容</div>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="5"> <div class="grid-content">运营商</div> </el-col>
          <el-col :span="5"> <div class="grid-content">卡类型</div> </el-col>
          <el-col :span="5">
            <div class="grid-content">套餐内容(注明配套餐出货或用户充值)</div>
          </el-col>
          <el-col :span="2"> <div class="grid-content">数量</div> </el-col>
          <el-col :span="2"> <div class="grid-content">单位</div> </el-col>
          <el-col :span="2"> <div class="grid-content">单价(元)</div> </el-col>
          <el-col :span="3">
            <div class="grid-content">总金额(元)</div>
          </el-col>
        </el-row>

        <el-row
          :gutter="20"
          v-for="(item, index) in formData.contentList"
          :key="item.id"
        >
          <el-col :span="5">
            <div class="grid-content-radio">
              <el-radio-group v-model="item.operatorName">
                <div class="grid-radio">
                  <el-radio label="0">中国移动</el-radio>
                </div>
                <div class="grid-radio">
                  <el-radio label="1">中国联通</el-radio>
                </div>
                <div class="grid-radio">
                  <el-radio label="2">中国电信</el-radio>
                </div>
              </el-radio-group>
            </div>
          </el-col>
          <el-col :span="5">
            <div class="grid-content-radio">
              <el-checkbox-group
                v-model="item.cardList"
                @change="(checked) => changeChecked(checked, index)"
              >
                <el-checkbox label="插拔卡三切">插拔卡三切</el-checkbox>
                <el-checkbox label="贴片卡5*6">贴片卡5*6</el-checkbox>
                <el-checkbox label="贴片卡2*2">贴片卡2*2</el-checkbox>
                <el-checkbox label="定向">定向</el-checkbox>
              </el-checkbox-group>
            </div>
          </el-col>
          <el-col :span="5">
            <div class="grid-content-radio">
              <el-input
                v-model="item.packageContent"
                clearable="true"
              ></el-input>
            </div>
          </el-col>
          <el-col :span="2">
            <div class="grid-content-radio">
              <el-input v-model="item.quantity" clearable="true"></el-input>
            </div>
          </el-col>
          <el-col :span="2">
            <div class="grid-content-radio">
              <el-input v-model="item.units" clearable="true"></el-input>
            </div>
          </el-col>
          <el-col :span="2">
            <div class="grid-content-radio">
              <el-input v-model="item.unitPrice" clearable="true"></el-input>
            </div>
          </el-col>
          <el-col :span="3">
            <div class="grid-content-radio">
              <el-input v-model="item.grossAmount" clearable="true"></el-input>
              <el-button
                v-show="true"
                @click.prevent="removeDomain(item)"
                style="margin-left: 10px"
                type="danger"
                size="mini"
                icon="el-icon-delete"
                circle
              ></el-button>
            </div>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="4"><div class="grid-content">运输方式</div></el-col>
          <el-col :span="8"
            ><div class="grid-content">
              <el-radio-group v-model="formData.modeOfTransport">
                <el-radio label="0">自提</el-radio>
                <el-radio label="1">送货</el-radio>
                <el-radio label="2">快递寄付</el-radio>
                <el-radio label="3">快递到付</el-radio>
              </el-radio-group>
            </div></el-col
          >
          <el-col :span="4"
            ><div class="grid-content">要求发货日期</div></el-col
          >
          <el-col :span="8"
            ><div class="grid-content">
              <el-date-picker
                v-model="formData.deliveryDate"
                type="date"
                format="yyyy-MM-dd"
                placeholder="选择日期"
              >
              </el-date-picker></div
          ></el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="4"><div class="grid-content">收货地址</div></el-col>
          <el-col :span="20"
            ><div class="grid-content">
              <el-input
                v-model="formData.shippingAddress"
                clearable="true"
              ></el-input></div
          ></el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="4"><div class="grid-content">收货人</div></el-col>
          <el-col :span="8"
            ><div class="grid-content">
              <el-input
                v-model="formData.consignee"
                clearable="true"
              ></el-input></div
          ></el-col>
          <el-col :span="4"><div class="grid-content">收货人电话</div></el-col>
          <el-col :span="8"
            ><div class="grid-content">
              <el-input
                v-model="formData.receivingPhone"
                clearable="true"
              ></el-input></div
          ></el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="4"><div class="grid-content">是否付款</div></el-col>
          <el-col :span="8"
            ><div class="grid-content">
              <el-radio-group v-model="formData.whetherToPay">
                <el-radio label="0">是</el-radio>
                <el-radio label="1">否</el-radio>
              </el-radio-group>
            </div></el-col
          >
          <el-col :span="4"><div class="grid-content">付款方式</div></el-col>
          <el-col :span="8"
            ><div class="grid-content">
              <el-radio-group v-model="formData.payMode">
                <el-radio label="0">对公转账</el-radio>
                <el-radio label="1">微信</el-radio>
                <el-radio label="2">支付宝</el-radio>
                <el-radio label="3">赠送</el-radio>
              </el-radio-group>
            </div></el-col
          >
        </el-row>

        <el-row :gutter="20">
          <el-col :span="4"
            ><div class="grid-content-image">支付凭证或申请说明（截图）</div></el-col
          >
          <el-col :span="20"
            ><div class="grid-content-image">
              <el-upload
                class="avatar-uploader"
                :action="url"
                accept=".jpg,.png"
                :show-file-list="false"
                :on-success="handlePayVoucherImgSuccess"
                :before-upload="beforeAvatarUpload"
              >
                <img
                  v-if="formData.payVoucher"
                  :src="formData.payVoucher"
                  class="avatar"
                />
                <svg-icon
                  v-if="!formData.payVoucher"
                  class="svg-avatar-uploader-icon"
                />
                <i
                  v-if="!formData.payVoucher"
                  class="el-icon-plus avatar-uploader-icon"
                ></i>
              </el-upload></div
          ></el-col>
        </el-row>
      </div>
      <el-button @click="addDomain">新增</el-button>
    </el-form>
  </div>
</template>
<script>
import { historicActivityPerson } from "@/api/api.js"; //流程实例分页查询
import { processFromData } from "@/api/api.js"; //附加单据
export default {
  data() {
    return {
      formData: {
        id: undefined,
        companyName: undefined,
        applyCause: undefined,
        useDevice: undefined,
        modeOfTransport: undefined,
        deliveryDate: undefined,
        shippingAddress: undefined,
        consignee: undefined,
        receivingPhone: undefined,
        whetherToPay: undefined,
        payMode: undefined,
        payVoucher: undefined,
        remark: undefined,
        contentList: [
          {
            id: undefined,
            operatorName: undefined,
            cardType: undefined,
            cardList: [],
            packageContent: undefined,
            quantity: undefined,
            units: undefined,
            unitPrice: undefined,
            grossAmount: undefined,
            shipmentRequestId: undefined,
          },
        ],
      },
      id: this.childId,
      processId: this.processId,
      srcList: [
        "https://fuss10.elemecdn.com/a/3f/3302e58f9a181d2509f3dc0fa68b0jpeg.jpeg",
        "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
      ],
      rules: {
        companyName: [
          { required: true, message: "请输入购货公司", trigger: "blur" },
        ],
        applyCause: [
          { required: true, message: "请输入申请原因", trigger: "blur" },
        ],
        useDevice: [
          {
            required: true,
            message: "请输入使用设备及其描述",
            trigger: "blur",
          },
        ],
        // remark: [
        //   { required: true, message: "请输入活动名称", trigger: "blur" },
        // ],
        operatorName: [
          { required: true, message: "请选择运营商", trigger: "blur" },
        ],
        cardType: [
          { required: true, message: "请选择卡类型", trigger: "blur" },
        ],
        packageContent: [
          { required: true, message: "请输入卡套餐", trigger: "blur" },
        ],
        quantity: [
          { required: true, message: "请输入数量", trigger: "blur" },
          { type: "number", message: "数量必须为数字" },
        ],
        units: [{ required: true, message: "请输入单位", trigger: "blur" }],
        unitPrice: [
          { required: true, message: "请输入单价", trigger: "blur" },
          { type: "number", message: "单价必须为数字" },
        ],
        grossAmount: [
          { required: true, message: "请输入总金额", trigger: "blur" },
          { type: "number", message: "总金额必须为数字" },
        ],
        modeOfTransport: [
          { required: true, message: "请选择运输方式", trigger: "blur" },
        ],
        deliveryDate: [
          {
            type: "date",
            required: true,
            message: "日期不能为空",
            trigger: "blur",
          },
        ],
        shippingAddress: [
          { required: true, message: "收货地址不能为空", trigger: "blur" },
        ],
        consignee: [
          { required: true, message: "收货人不能为空", trigger: "blur" },
        ],
        receivingPhone: [
          { required: true, message: "收货人电话不能为空", trigger: "blur" },
        ],
      },

      //   queryParams: {},
      //   tableData: [],
      //   page: 1,
      //   pageSize: 20,
      //   total: 0,
    };
  },
  props: {
    childId: {
      type: String,
    },
    childProcessId: {
      type: String,
    },
    fromType: {
      type: Number,
    },
  },
  methods: {
    changeChecked(checked, idx) {
      this.formData.contentList[idx].cardType = checked.join();
    },
    removeDomain(item) {
      var index = this.formData.contentList.indexOf(item);
      if (index !== -1) {
        this.formData.contentList.splice(index, 1);
      }
    },
    addDomain() {
      this.formData.contentList.push({
        key: Date.now,
        id: undefined,
        operatorName: undefined,
        //   cardType: undefined,
        cardList: [],
        packageContent: undefined,
        quantity: undefined,
        units: undefined,
        unitPrice: undefined,
        grossAmount: undefined,
        shipmentRequestId: undefined,
      });
    },
    initData() {
      let params = {
        processInstanceId: this.childProcessId,
        taskId: this.childId,
      };
      //   processInstanceImage(params).then(res=>{
      //     this.str = res.data
      //   });
      processFromData(params).then((res) => {
        if (res.data.code == 200) {
          this.formData = res.data.data.ShipmentRequest;
        }
      });
    },
    // 上传支付凭证图片
    handlePayVoucherImgSuccess(res, file) {
      if (res.code == 200) {
        this.formData.payVoucher = "/cms/" + res.data.url;
      }
    },
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
      }
      return isLt2M;
    },

    // 历史
    // editRow(id) {
    //   this.$router.push({ path: `/procedure/lcslHistory?id=${id}` });
    // },
    // 搜索
    // search() {
    //   (this.page = 1), this.initData();
    // },
    // 重置
    // resetForm() {
    //   for (var i in this.queryParams) {
    //     this.queryParams[i] = null;
    //   }
    //   this.initData();
    // },
    // handleSizeChange(pageSize) {
    //   this.pageSize = pageSize;
    //   this.initData();
    // },
    // handleCurrentChange(page) {
    //   this.page = page;
    //   this.initData();
    // },
  },
  mounted() {
    this.initData();
  },
  created() {},
  // watch: {
  //   formData: {
  //     handler(newval, oldval) {
  //       console.log("表单数据修改",newval, oldval)
  //       // this.$emit("update-form", newVal); // 数据变化时触发事件
  //       this.$emit('update:formData', newval)
  //     },
  //     deep: true, // 深度监听对象变化
  //   },
  // },
};
</script>
<style scoped lang="less">
.grid-radio {
  margin-top: 5px;
  margin-bottom: 5px;
}

.el-row {
  //   margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-col {
  border-radius: 0px;
  //   min-height: 36px;
  border: 1px solid #4d4d4d;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 46px;
  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: center;
}

.grid-content-image {
  border-radius: 4px;
  min-height: 300px;
  padding: 10px;
  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: center;
}

.grid-content-radio {
  border-radius: 4px;
  min-height: 100px;
  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: center;
}

.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}

div.table-container {
  margin-top: 50px;
  margin-left: 220px;
  max-width: 1200px;
  padding: 20px;
  border-radius: 5px;
  border: 1px solid black;
  table.table-layout {
    table-layout: fixed;
    border-collapse: collapse;
    width: 1080px;

    td.table-cell {
      display: table-cell;
      height: 36px;
      border: 1px solid black;
      text-align: center;
    }
  }
}
.table-checkbox,
.table-radio {
  display: table-cell;
  border: 1px solid black;
  text-align: left;
}

.add-button {
  margin-top: -340px;
  margin-right: -10px;
  float: right;
  position: relative;
}
.save {
  margin-top: 50px;
  margin-left: 750px;
  position: relative;
}
.text-input {
  width: 100%;
  height: 100%;
  padding: 5px;
  border: 1px #ccc;
  border-radius: 4px;
  box-sizing: border-box;
  text-align: center;
}
.radio-input {
  vertical-align: middle;
  margin-top: -2px;
  margin-bottom: 1px;
}
.avatar-uploader {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 138px;
  height: 138px;
}
.avatar-uploader:hover {
  border-color: #409eff;
}
.svg-avatar-uploader-icon {
  font-size: 28px;
  width: 60px;
  height: 60px;
  line-height: 18px;
  text-align: center;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 138px;
  height: 138px;
  // line-height: 88px;
  text-align: center;
}
.avatar {
  width: 138px;
  height: 138px;
  display: block;
}
.avatar-uploader .el-upload {
  border: 0px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>


